var map = {
	"./adobe-xd.svg": [
		60829,
		60829
	],
	"./adobeXD.svg": [
		68651,
		68651
	],
	"./after-effects.svg": [
		44090,
		44090
	],
	"./agency.svg": [
		81872,
		81872
	],
	"./ai-file-icon.svg": [
		73303,
		73303
	],
	"./ai-icon.svg": [
		81117,
		81117
	],
	"./airtable-backup.svg": [
		71682,
		71682
	],
	"./arrow-black.svg": [
		66661,
		66661
	],
	"./arrow-down.svg": [
		49756,
		49756
	],
	"./arrow-pointer.svg": [
		16730,
		16730
	],
	"./arrow-right-grey.svg": [
		70667,
		70667
	],
	"./arrow-right-small.svg": [
		97685,
		97685
	],
	"./arrow-right.svg": [
		65458,
		65458
	],
	"./arrow-white.svg": [
		68810,
		68810
	],
	"./axure-icon.svg": [
		9126,
		9126
	],
	"./backup-icon.svg": [
		101,
		101
	],
	"./balance-icon.svg": [
		68586,
		68586
	],
	"./blog-icon.svg": [
		2297,
		2297
	],
	"./bolt-icon.svg": [
		30655,
		30655
	],
	"./box.svg": [
		4030,
		4030
	],
	"./bubble-icon.svg": [
		67862,
		67862
	],
	"./canva-file-icon.svg": [
		57908,
		57908
	],
	"./canva.svg": [
		36093,
		36093
	],
	"./chat.svg": [
		95811,
		95811
	],
	"./check-circled-empty.svg": [
		44329,
		44329
	],
	"./check-circled-icon.svg": [
		31502,
		31502
	],
	"./check-green-icon.svg": [
		45295,
		45295
	],
	"./check-icon-empty.svg": [
		2509,
		2509
	],
	"./check-icon.svg": [
		41199,
		41199
	],
	"./check.svg": [
		98846,
		98846
	],
	"./chevron.svg": [
		83525,
		83525
	],
	"./clock.svg": [
		22976,
		22976
	],
	"./close-circled.svg": [
		88387,
		88387
	],
	"./close.svg": [
		80378,
		80378
	],
	"./cms-icon-light.svg": [
		51659,
		51659
	],
	"./cms-icon.svg": [
		47881,
		47881
	],
	"./company-icon.svg": [
		35318,
		35318
	],
	"./components-icon.svg": [
		13355,
		13355
	],
	"./connect-figma.svg": [
		16345,
		16345
	],
	"./contact-icon.svg": [
		38906,
		38906
	],
	"./converter-icon.svg": [
		73474,
		73474
	],
	"./corrupted-icon.svg": [
		70138,
		70138
	],
	"./data-security.svg": [
		45390,
		45390
	],
	"./demo-icon.svg": [
		37309,
		37309
	],
	"./design-file-graphic.svg": [
		11301,
		11301
	],
	"./design-file.svg": [
		74113,
		74113
	],
	"./design-tool-icon.svg": [
		43107,
		43107
	],
	"./development.svg": [
		93795,
		93795
	],
	"./disconnect.svg": [
		93104,
		93104
	],
	"./download-icon.svg": [
		47332,
		47332
	],
	"./encryption.svg": [
		89278,
		89278
	],
	"./enterprise-icon.svg": [
		78418,
		78418
	],
	"./eps-icon.svg": [
		4480,
		4480
	],
	"./error-icon.svg": [
		24701,
		24701
	],
	"./exclamation-mark.svg": [
		56863,
		56863
	],
	"./express.svg": [
		74862,
		74862
	],
	"./external.svg": [
		34456,
		34456
	],
	"./eye-invisible.svg": [
		54212,
		54212
	],
	"./eye-visible.svg": [
		85826,
		85826
	],
	"./eye.svg": [
		31240,
		31240
	],
	"./facebook.svg": [
		61156,
		61156
	],
	"./facebook_2.svg": [
		97880,
		97880
	],
	"./figjam-file-icon.svg": [
		54674,
		54674
	],
	"./figjam-icon.svg": [
		65945,
		65945
	],
	"./figma-backup-graphic.svg": [
		95762,
		95762
	],
	"./figma-backup.svg": [
		18051,
		18051
	],
	"./figma-file-icon.svg": [
		14222,
		14222
	],
	"./figma.svg": [
		82353,
		82353
	],
	"./file-icon.svg": [
		32245,
		32245
	],
	"./file-migration.svg": [
		71637,
		71637
	],
	"./file-not-found-icon.svg": [
		87121,
		87121
	],
	"./file-support-icon.svg": [
		62203,
		62203
	],
	"./fill-icon.svg": [
		78067,
		78067
	],
	"./finger-print.svg": [
		1476,
		1476
	],
	"./flow-icon.svg": [
		55592,
		55592
	],
	"./folder-icon.svg": [
		50920,
		50920
	],
	"./folder-simple-icon.svg": [
		84630,
		84630
	],
	"./free-icon.svg": [
		77101,
		77101
	],
	"./freehand.svg": [
		88981,
		88981
	],
	"./gear.svg": [
		41930,
		41930
	],
	"./globe-icon.svg": [
		53279,
		53279
	],
	"./google-slides-file-icon.svg": [
		66357,
		66357
	],
	"./google-slides.svg": [
		71926,
		71926
	],
	"./gradient-icon.svg": [
		8326,
		8326
	],
	"./help-icon.svg": [
		9473,
		9473
	],
	"./hosting.svg": [
		14206,
		14206
	],
	"./html-icon.svg": [
		59016,
		59016
	],
	"./image-icon.svg": [
		49823,
		49823
	],
	"./image-red-icon.svg": [
		2720,
		2720
	],
	"./indesign-file-icon.svg": [
		42229,
		42229
	],
	"./indesign.svg": [
		15995,
		15995
	],
	"./info-empty.svg": [
		81124,
		81124
	],
	"./info.svg": [
		95885,
		95885
	],
	"./instagram-icon.svg": [
		62555,
		62555
	],
	"./integration-icon.svg": [
		43133,
		43133
	],
	"./jpg.svg": [
		93776,
		93776
	],
	"./keynote.svg": [
		41816,
		41816
	],
	"./letter-icon.svg": [
		61956,
		61956
	],
	"./lock-dot-icon.svg": [
		85693,
		85693
	],
	"./lock-icon.svg": [
		1099,
		1099
	],
	"./lock.svg": [
		58800,
		58800
	],
	"./logout-icon.svg": [
		40692,
		40692
	],
	"./lucidchart.svg": [
		87996,
		87996
	],
	"./magicul-comments.svg": [
		88594,
		88594
	],
	"./magicul-x.svg": [
		62925,
		62925
	],
	"./magicul.svg": [
		69334,
		69334
	],
	"./medium-icon.svg": [
		74593,
		74593
	],
	"./minus.svg": [
		4642,
		4642
	],
	"./miro-backup-graphic.svg": [
		31284,
		31284
	],
	"./miro-backup.svg": [
		66409,
		66409
	],
	"./miro-file-icon.svg": [
		58621,
		58621
	],
	"./miro-icon.svg": [
		16212,
		16212
	],
	"./mural.svg": [
		2305,
		2305
	],
	"./new-jpg-file.svg": [
		7417,
		7417
	],
	"./new-lock.svg": [
		59567,
		59567
	],
	"./new-pdf-file.svg": [
		70454,
		70454
	],
	"./new-png-file.svg": [
		76245,
		76245
	],
	"./no-preview.svg": [
		58999,
		58999
	],
	"./notes-icon.svg": [
		38465,
		38465
	],
	"./open-external.svg": [
		16848,
		16848
	],
	"./outdated-icon.svg": [
		77698,
		77698
	],
	"./oval-copy-10.svg": [
		98763,
		98763
	],
	"./owl.svg": [
		61440,
		61440
	],
	"./partial.svg": [
		36149,
		36149
	],
	"./pdf-file-icon.svg": [
		32121,
		32121
	],
	"./pdf-icon.svg": [
		88775,
		88775
	],
	"./pen-icon.svg": [
		6610,
		6610
	],
	"./photoshop-icon.svg": [
		52406,
		52406
	],
	"./piggy-1.svg": [
		83408,
		83408
	],
	"./play-icon-big.svg": [
		62030,
		62030
	],
	"./plugin-icon.svg": [
		79210,
		79210
	],
	"./plus-circled.svg": [
		54183,
		54183
	],
	"./plus.svg": [
		3849,
		3849
	],
	"./plus2.svg": [
		70150,
		70150
	],
	"./powerpoint-file-icon.svg": [
		88880,
		88880
	],
	"./powerpoint.svg": [
		36094,
		36094
	],
	"./privacy-icon.svg": [
		98208,
		98208
	],
	"./psd-file-icon.svg": [
		84221,
		84221
	],
	"./quotes-icon.svg": [
		46383,
		46383
	],
	"./refresh-2.svg": [
		23381,
		23381
	],
	"./refresh.svg": [
		76246,
		76246
	],
	"./rhomb-icon.svg": [
		35820,
		35820
	],
	"./scroll-down-icon.svg": [
		95536,
		95536
	],
	"./settings.svg": [
		15252,
		15252
	],
	"./share-icon.svg": [
		94418,
		94418
	],
	"./sheets.svg": [
		56836,
		56836
	],
	"./shield-alert.svg": [
		69895,
		69895
	],
	"./shield-icon.svg": [
		50713,
		50713
	],
	"./shield.svg": [
		79004,
		79004
	],
	"./sketch-file-icon.svg": [
		6154,
		6154
	],
	"./sketch.svg": [
		79806,
		79806
	],
	"./slack.svg": [
		66855,
		66855
	],
	"./spinner-icon.svg": [
		80351,
		80351
	],
	"./spread-icon.svg": [
		9132,
		9132
	],
	"./square-icon.svg": [
		293,
		293
	],
	"./star-2.svg": [
		9146,
		9146
	],
	"./star-3.svg": [
		54059,
		54059
	],
	"./star-4.svg": [
		94445,
		94445
	],
	"./star.svg": [
		85119,
		85119
	],
	"./support.svg": [
		45396,
		45396
	],
	"./switch-icon.svg": [
		4966,
		4966
	],
	"./sync-icon.svg": [
		82110,
		82110
	],
	"./sync-red-icon.svg": [
		33630,
		33630
	],
	"./t-icon.svg": [
		27985,
		27985
	],
	"./team-collaboration.svg": [
		86166,
		86166
	],
	"./text-icon.svg": [
		92812,
		92812
	],
	"./time-blue-icon.svg": [
		10869,
		10869
	],
	"./time-icon.svg": [
		82102,
		82102
	],
	"./tip-arrow-icon-big.svg": [
		9888,
		9888
	],
	"./tip-arrow-icon.svg": [
		96292,
		96292
	],
	"./together-icon.svg": [
		79242,
		79242
	],
	"./tool-menu.svg": [
		1575,
		1575
	],
	"./trash.svg": [
		87330,
		87330
	],
	"./triangle-down.svg": [
		81688,
		81688
	],
	"./triangle-up.svg": [
		58997,
		58997
	],
	"./tv.svg": [
		37510,
		37510
	],
	"./twitter.svg": [
		35149,
		35149
	],
	"./user-dark.svg": [
		46929,
		46929
	],
	"./user-icon.svg": [
		86814,
		86814
	],
	"./visio-icon.svg": [
		63274,
		63274
	],
	"./warning-icon.svg": [
		383,
		383
	],
	"./webflow-icon.svg": [
		50913,
		50913
	],
	"./website-icon.svg": [
		80656,
		80656
	],
	"./wordpress-icon.svg": [
		6794,
		6794
	],
	"./xd-file-icon.svg": [
		3684,
		3684
	],
	"./youtube.svg": [
		70830,
		70830
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 35367;
module.exports = webpackAsyncContext;